/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/header',['../localization/labels', './components'], function(labels, components) {
    'use strict';
    var chartHeaderStyle = {
        fillColor: '#e5e5e5',
        fontSize: 10,
        margin: [10, 5, 10, 5]
    };

    return {
        chartHeaderStyle: chartHeaderStyle,
        getHeader: getHeader
    };

    /**
     * Function to create header for the pdf from the given data
     * @param  input data to be used for making the header
     * @return array of javascript objects according to the pdfmake format
     */
    function getHeader(inputData) {
        return function() {
            // sub-heading columns
            var subHeadingColumns = [{
                margin: [40, 5, 0, 0],
                text: labels.header.pdfGenerationText + inputData.generationDate.value,
                fontSize: 8,
                alignment: 'left'
            }];
            // report header
            return [{
                    columns: [{
                        text: inputData.reportTitle,
                        fontSize: 22,
                        color: '#78a5c8',
                        alignment: 'left'
                    }, {
                        image: inputData.logoImage,
                        alignment: 'right',
                        height: 25,
                        width: 75
                    }],
                    margin: [40, 20, 40, 5]
                },
                components.getHorizontalLine([20, 5, 20, 0]), {
                    columns: subHeadingColumns
                }
            ];
        };
    }
});
